import React from 'react';

// 中断からの再開時に「なぜ問1ではないのか」を学習者に伝える一言。
// 再開したステップにいる間だけ出し、次へ進むと消える。
export default function ResumeNotice({ questionNumber }) {
  if (!questionNumber) return null;
  return (
    <p className="resume-notice">
      前回の続き（問{questionNumber}）から再開しました
    </p>
  );
}
